import { render, staticRenderFns } from "./StudioTable.vue?vue&type=template&id=73f8ce82"
import script from "./StudioTable.vue?vue&type=script&lang=js"
export * from "./StudioTable.vue?vue&type=script&lang=js"
import style0 from "./StudioTable.vue?vue&type=style&index=0&id=73f8ce82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports